<template>
  <a-modal title="优惠券详情" :width="900" :visible="visible" :confirmLoading="confirmLoading" :footer="false"
    @cancel="handleCancel" v-if="hackReset">
    <div class="viewDetial-tiem">
      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:15px">券名称：{{ this.userDate.name }}</label>
        </a-col>
        <a-col :span="12">
          <label style="padding-left:28px">兑换码：{{ this.userDate.exchangeCode }}</label>
        </a-col>
      </a-row>
      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:15px">券编码：{{ this.userDate.code }}</label>
        </a-col>
        <a-col :span="12">
          <label style="padding-left:28px">状态：{{ this.userDate.status == '0' ? '未激活' : this.userDate.status == '1' ? '已激活' : this.userDate.status == '2' ? '已使用' : this.userDate.status == '3' ? '已过期' : '---' }}</label>
        </a-col>
      </a-row>
      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:15px">创建时间：{{ this.userDate.createTime }}</label>
        </a-col>
        <a-col :span="12">
          <label style="padding-left:28px">使用时间：{{ this.userDate.useTime ? this.userDate.useTime : '---' }}</label>
        </a-col>
      </a-row>
      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:15px">有效期：{{ this.userDate.validDate }}</label>
        </a-col>
        <a-col :span="12">
          <label style="padding-left:28px">使用订单：{{ this.userDate.orderId ? this.userDate.orderId : '---' }}</label>
        </a-col>
      </a-row>
      <a-row style="height:30px">
        <a-col >
          <label style="padding-left:15px">金额：<span  style="color:#D9001B">{{ (Number(this.userDate.amount)).toFixed(2) }} 元</span>  </label>
        </a-col>
    
      </a-row>
    </div>
  </a-modal>
</template>

<script>
  import { assessDetial } from '@/api/modular/interhospital/assessQuery/assessQueryMange'
  import { buCouponDetail } from '@/api/modular/interhospital/bucoupon/buCouponManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        ctstampDateString: '',
        birthdayDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        parameter : {},
        userDate : '',
        hackReset: true,
        status : '',
        srcList:[]
        
      }
    },
    methods: {
      // 初始化方法
      add (record) {
        console.log('优惠券详情',record)
        this.parameter.couponId = record.id;
        this.status = record.status
        this.visible = true;
        buCouponDetail(this.parameter).then(res=>{
          console.log('res.data===', res.data)
          this.userDate = res.data;
        });
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      }
    }
  }
</script>
<style lang="less" scoped>
.srcListSize{
  width:70px;
  height:70px;
  margin-right: 10px;
}
.viewDetial-tiem{
  margin-bottom: 10px;
}
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
  .viewDetial-title-notes{
    font-weight: 400;
    font-size: 13px;
    color: rgba(127, 127, 127, 0.847058823529412);
    margin-left: 15px;
  }
}
</style>
